/* unplugin-vue-components disabled */import { render } from "./newsdetail.vue?vue&type=template&id=4e0d1bfb"
import script from "./newsdetail.vue?vue&type=script&lang=js"
export * from "./newsdetail.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__